import { Grid, makeStyles } from '@material-ui/core';
import Account from 'components/molecules/Account';
import { AuthContext } from 'context/auth/AuthContext';
import React, { useContext } from 'react';

const useStyles = makeStyles((theme) => ({
    header: {
        height: '75px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.main,
    },
    container: {
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    account: {
        marginRight: 50,
        color: 'white',
        display: 'flex',
        flexDirection: 'row',
    },
    gallery: {
        marginRight: 25,
    },
}));

const Header = () => {
    const classes = useStyles();
    const { state } = useContext(AuthContext);

    return (
        <header className={classes.header}>
            <Grid container className={classes.container}>
                <Grid item className={classes.account}>
                    <Account name={state?.user?.name} />
                </Grid>
            </Grid>
        </header>
    );
};

export default Header;
